import { ClearIndicatorProps } from "react-select";
import { CSSObject } from "@emotion/serialize";
import React, { CSSProperties } from "react";
import CloseX from "./gfx/CloseX";

export const ClearIndicator = (props: ClearIndicatorProps<any, false>) => {
  const {
    children = <CloseX />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles("clearIndicator", props) as CSSProperties}
    >
      <div style={{ padding: "0px 5px" }}>{children}</div>
    </div>
  );
};

export const ClearIndicatorMulti = (props: ClearIndicatorProps<any, true>) => {
  const {
    children = <CloseX />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles("clearIndicator", props) as CSSProperties}
    >
      <div style={{ padding: "0px 5px" }}>{children}</div>
    </div>
  );
};

export const ClearIndicatorStyles = (
  base: CSSObject,
  state: ClearIndicatorProps<any>,
): CSSObject => ({
  ...base,
  cursor: "pointer",
  fill: "var(--ver-btn-color)",
  paddingTop: "4px",
});
